"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildOrganisationInfoPayload;

var _deepObjectChanges = _interopRequireDefault(require("deep-object-changes"));

var _stripCacheKeysFromData = _interopRequireDefault(require("@devsta/strip-cache-keys-from-data"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function stripEmptyStrings(object) {
  return Object.keys(object).reduce(function (newObject, key) {
    return _objectSpread({}, newObject, _defineProperty({}, key, object[key] || null));
  }, {});
}

function buildOrganisationInfoPayload(originalPayload, newPayload) {
  var payload = stripEmptyStrings((0, _stripCacheKeysFromData.default)(newPayload));
  return (0, _deepObjectChanges.default)(originalPayload, payload);
}